import { persistSearchSessionState, readSearchSessionState } from "@/vue/utils/searchSessionStorage";

const STORAGE_KEY = "face_sheets/top_search_form";

export function persistSearchForm(searchForm: object | null): void {
  persistSearchSessionState(STORAGE_KEY, searchForm);
}

export function readPersistedSearchForm(): object | null {
  return readSearchSessionState(STORAGE_KEY);
}
